module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(_vm.up) ? _c('div', {
    staticClass: "del-block m-t-5"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', [(_vm.brandBrief.length > 1 && !_vm.up) ? _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定名稱\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定描述\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad",
    staticStyle: {
      "max-width": "calc(30vw - 190px)"
    }
  }, [_vm._m(2), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad",
    staticStyle: {
      "max-width": "calc(30vw - 190px)"
    }
  }, [_vm._m(3), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addRule
    }
  }, [_vm._v("新增規則")])]), _vm._v(" "), _vm._l((_vm.rule_list), function(rule, rIndex) {
    return _c('div', {
      staticClass: "process-time-block",
      staticStyle: {
        "max-width": "400px"
      }
    }, [_c('div', {
      staticClass: "text-right m-b-10"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.rule_list, rIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', [_c('multiselect', {
      attrs: {
        "placeholder": "規則類型",
        "label": "label",
        "track-by": "value",
        "options": _vm.ruleTypeOptions,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (rule.rule_type),
        callback: function($$v) {
          _vm.$set(rule, "rule_type", $$v)
        },
        expression: "rule.rule_type"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), (rule.rule_type.value === 1) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', [_c('date-time-picker', {
      attrs: {
        "date": rule.rule_date,
        "option": _vm.dateoption_rule,
        "limit": _vm.limit_rule
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (rule.rule_type.value === 2 || rule.rule_type.value === 3) ? _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon",
      staticStyle: {
        "width": "120px",
        "text-align": "left"
      }
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(rule.rule_type.value === 2 ? '星期' : '日期') + "\n                  ")]), _vm._v(" "), _c('div', [(rule.rule_type.value === 2) ? _c('multiselect', {
      staticStyle: {
        "width": "248px"
      },
      attrs: {
        "placeholder": "星期",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdaySetting.options.weekDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (rule.rule_day),
        callback: function($$v) {
          _vm.$set(rule, "rule_day", $$v)
        },
        expression: "rule.rule_day"
      }
    }) : (rule.rule_type.value === 3) ? _c('multiselect', {
      staticStyle: {
        "width": "248px"
      },
      attrs: {
        "placeholder": "幾號",
        "label": "label",
        "track-by": "value",
        "options": _vm.offdateSetting.options.dateDay,
        "multiple": false,
        "allow-empty": true
      },
      model: {
        value: (rule.rule_month_day),
        callback: function($$v) {
          _vm.$set(rule, "rule_month_day", $$v)
        },
        expression: "rule.rule_month_day"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.rule_month_day),
        expression: "rule.rule_month_day"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "日期",
        "type": "text",
        "maxlength": "1"
      },
      domProps: {
        "value": (rule.rule_month_day)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "rule_month_day", $event.target.value)
        }
      }
    })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon",
      staticStyle: {
        "width": "120px",
        "text-align": "left"
      }
    }, [_vm._v("\n                    起始時間\n                  ")]), _vm._v(" "), _c('div', [_c('vue-timepicker', {
      attrs: {
        "manual-input": "",
        "placeholder": "hh:mm",
        "input-width": "248px",
        "input-class": "form-control"
      },
      model: {
        value: (rule.rule_start_time),
        callback: function($$v) {
          _vm.$set(rule, "rule_start_time", $$v)
        },
        expression: "rule.rule_start_time"
      }
    })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon",
      staticStyle: {
        "width": "120px",
        "text-align": "left"
      }
    }, [_vm._v("\n                    結束時間\n                  ")]), _vm._v(" "), _c('div', [_c('vue-timepicker', {
      attrs: {
        "manual-input": "",
        "placeholder": "hh:mm",
        "input-width": "248px",
        "input-class": "form-control"
      },
      model: {
        value: (rule.rule_end_time),
        callback: function($$v) {
          _vm.$set(rule, "rule_end_time", $$v)
        },
        expression: "rule.rule_end_time"
      }
    })], 1)]), _vm._v(" "), _c('br')])])
  })], 2)]), _vm._v(" "), (_vm.addStoresSetting.options.length > 0 && (_vm.$route.query.usage_type === '1' && _vm.$route.name === 'upDisableSchedule' || _vm.$route.name === 'crDisableSchedule')) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._m(7), _vm._v(" "), (_vm.addStoresSetting.options.length > 0) ? _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.addStoresSetting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "show-select-all-buttons": _vm.checkSelectAll,
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.addStoresSetting.choose),
      callback: function($$v) {
        _vm.$set(_vm.addStoresSetting, "choose", $$v)
      },
      expression: "addStoresSetting.choose"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(this.addStoresSetting.choose.length) + " 間")])])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.category.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.category.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("商品時段停賣設定")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [_c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_disabled),
        expression: "c.is_disabled"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_disabled) ? _vm._i(c.is_disabled, null) > -1 : (c.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_disabled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.product_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.child_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {
        class: p.is_disabled ? 'delete-line' : ''
      }, [_vm._v("\n                            " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark ? ("(" + (p.remark) + ")") : ''))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'p-' + p.product_id + '-is-add'
        }
      })])])])])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            新增\n          ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            更新\n          ")])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delItemOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("規則類型\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "120px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("日期\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-t-64 y-middle"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [_c('h5', {
    staticClass: "text-14-4 "
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("多店編輯限同菜單")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0"
  }, [_c('div', {
    staticClass: "left_store_sec text-14-4 "
  }, [_vm._v("不參與停賣店家")]), _vm._v(" "), _c('div', {
    staticClass: "middle_store_sec"
  }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticClass: "right_store_sec text-14-4 "
  }, [_vm._v("參與停賣店家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選者，將會取消停賣功能。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-b-5 text-left p-x-15"
  }, [_c('div', {
    staticClass: "text-right inline-block block-checkbox text-15",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "text-dark-gray text-13"
  }, [_vm._v("停賣")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-533d231c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/DisScheduleProdTemp.vue
// module id = 2420
// module chunks = 1